
export {CKEditorError,
Collection,
Config,
DOCUMENTATION_URL,
DomEmitterMixin,
ElementReplacer,
EmitterMixin,
EventInfo,
FocusTracker,
KeystrokeHandler,
Locale,
ObservableMixin,
Rect,
ResizeObserver,
_clearTranslations,
_getEmitterId,
_getEmitterListenedTo,
_getUserAgent,
_isAndroid,
_isBlink,
_isGecko,
_isMac,
_isMediaForcedColors,
_isMotionReduced,
_isRegExpUnicodePropertySupported,
_isSafari,
_isWindows,
_isiOS,
_setEmitterId,
_translate,
_unifyTranslations,
abortableDebounce,
add,
areConnectedThroughProperties,
collectStylesheets,
compareArrays,
count,
crc32,
createElement,
delay,
diff,
diffToChanges,
env,
exponentialDelay,
fastDiff,
findClosestScrollableAncestor,
first,
formatHtml,
getAncestors,
getBorderWidths,
getCode,
getCommonAncestor,
getDataFromElement,
getEnvKeystrokeText,
getLanguageDirection,
getLocalizedArrowKeyCodeDirection,
getOptimalPosition,
getPositionedAncestor,
getRangeFromMouseEvent,
getVisualViewportOffset,
global,
indexOf,
insertAt,
insertToPriorityArray,
isArrowKeyCode,
isCombiningMark,
isComment,
isForwardArrowKeyCode,
isHighSurrogateHalf,
isInsideCombinedSymbol,
isInsideEmojiSequence,
isInsideSurrogatePair,
isIterable,
isLowSurrogateHalf,
isNode,
isRange,
isText,
isValidAttributeName,
isViewWithFocusTracker,
isVisible,
isWindow,
keyCodes,
logError,
logWarning,
mapsEqual,
nth,
objectToMap,
parseBase64EncodedObject,
parseKeystroke,
priorities,
releaseDate,
remove,
retry,
scrollAncestorsToShowTarget,
scrollViewportToShowTarget,
setDataInElement,
spliceArray,
spy,
toArray,
toMap,
toUnit,
uid,
version,
wait} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-utils$dist$index.js.js';
